import { render, staticRenderFns } from "./StopExL.vue?vue&type=template&id=883ef2d8"
import script from "./StopExL.vue?vue&type=script&lang=js"
export * from "./StopExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports